var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bj-tooltip"},[_c('el-tooltip',{attrs:{"placement":_vm.placement,"effect":_vm.$theme.tooltipKey(),"content":_vm.content,"popper-class":"common-panel-tooltip-box"}},[_c('template',{slot:"content"},[_vm._t("content")],2),[_vm._t("default")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }